// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from 'firebase/firestore';
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyClHwrbsEaFMKSAphZecX5ibIGLOQ_XApA",
  authDomain: "inin.app",
  projectId: "theinin",
  storageBucket: "theinin.appspot.com",
  messagingSenderId: "604034742997",
  appId: "1:604034742997:web:2dc60853ab90ddcb86005c",
  measurementId: "G-B5J8LHRQ4F"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);

export const firestore = getFirestore(app);
export const storage = getStorage(app);